import { Divider } from '@mui/material';
import { InfoItem, SidebarItem } from '/src/components';
import { Lender } from '/src/lib/models';

export type LenderOverviewProps = {
  /**
   * Whether this component is visible
   */
  open: boolean;
  /**
   * Toggles component visibility
   * @returns void
   */
  toggleOpen: () => void;
  /**
   * Lender to display overview for
   */
  lender?: Lender;
};

export const LenderOverview: React.FC<LenderOverviewProps> = ({ lender, open, toggleOpen }) => (
  <SidebarItem
    title="Investor Overview (YTD)"
    open={open}
    toggleOpen={toggleOpen}
    toggleTooltip="Toggles the Investor Overview sidebar item"
    resolved={!!lender}
  >
    <InfoItem title="Current Principal Balances (YTD)" value={lender?.ytd.principalBalance} currency />
    <Divider />
    <InfoItem title="Fees Collected (YTD)" value={lender?.ytd.appliedToFees} currency />
    <InfoItem title="Interest Collected (YTD)" value={lender?.ytd.appliedToInterest} currency />
    <InfoItem title="Total Revenue (YTD)" value={lender?.ytd.totalRevenue} bold currency />
    <InfoItem title="Socket Fees (YTD)" value={lender?.ytd.managementFees} currency />
    <InfoItem title="Net Revenue Collected (YTD)" value={lender?.ytd.netRevenue} bold currency />
  </SidebarItem>
);
